/**
 * Safe localStorage wrapper — prevents crashes in private browsing,
 * storage quota exceeded, or SSR environments.
 */
export const safeStorage = {
  getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch {
      // Quota exceeded or private browsing
    }
  },
  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch {
      // Ignore
    }
  },
};

/**
 * Safe sessionStorage wrapper — same guarantees as `safeStorage` but scoped to
 * the tab session. Used by the ARIA conversation store to persist the live
 * conversation snapshot so it survives navigation + reload without leaking into
 * the next tab/session.
 */
export const safeSessionStorage = {
  getItem(key) {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      // Quota exceeded or private browsing
    }
  },
  removeItem(key) {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // Ignore
    }
  },
};
